import type { ReactNode } from 'react'
import { GROUPED_STATIC_TEXT_ROLE } from '../ui-components/NameValueTableRow'

type HelpDialogPassageProps = {
  /** Full announcement for this passage (title + body when both exist). */
  accessibleLabel: string
  children: ReactNode
  className?: string
}

/**
 * One TalkBack/VoiceOver focus stop for a help-dialog passage (Reg_Details_B04).
 * Visual children stay aria-hidden so styled spans do not split or merge focus.
 */
export function HelpDialogPassage({ accessibleLabel, children, className }: HelpDialogPassageProps) {
  return (
    <p role={GROUPED_STATIC_TEXT_ROLE} aria-label={accessibleLabel} className={`m-0 ${className ?? ''}`}>
      <span aria-hidden='true'>{children}</span>
    </p>
  )
}
